import React, { useCallback, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemText } from '@mui/material';
import { createSnapshot, listRevisions, restoreRevision } from '../api';
import { PresentationRecord, PresentationRevision } from '../types';

interface HistoryPanelProps {
  open: boolean;
  presentationId: string;
  onClose: () => void;
  onRestored: (presentation: PresentationRecord) => void;
}

const HistoryPanel: React.FC<HistoryPanelProps> = ({ open, presentationId, onClose, onRestored }) => {
  const [revisions, setRevisions] = useState<PresentationRevision[]>([]);

  const reload = useCallback(() => {
    listRevisions(presentationId).then(setRevisions).catch(() => setRevisions([]));
  }, [presentationId]);

  useEffect(() => {
    if (open) reload();
  }, [open, reload]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Historik</DialogTitle>
      <DialogContent>
        <Button
          variant="outlined"
          onClick={async () => {
            await createSnapshot(presentationId);
            reload();
          }}
          sx={{ mb: 2 }}
        >
          Spara ögonblicksbild nu
        </Button>
        <List>
          {revisions.map((revision) => (
            <ListItem
              key={revision._id}
              secondaryAction={
                revision.snapshot ? (
                  <Button onClick={async () => {
                    if (!window.confirm('Vill du återställa den här versionen? Nuvarande innehåll ersätts.')) return;
                    const restored = await restoreRevision(presentationId, revision.revision);
                    onRestored(restored);
                  }}>
                    Återställ
                  </Button>
                ) : null
              }
            >
              <ListItemText
                primary={`Revision ${revision.revision} · ${revision.cause === 'snapshot' ? 'ögonblicksbild' : revision.cause === 'restore' ? 'återställd' : revision.cause === 'ready' ? 'klar' : 'autospar'}`}
                secondary={new Date(revision.createdAt).toLocaleString('sv-SE')}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Stäng</Button>
      </DialogActions>
    </Dialog>
  );
};

export default HistoryPanel;
